import {Component} from '@angular/core';

import { settings, Settings } from 'app/core/settings';

@Component({
    selector: 'auth-footer',
    templateUrl: 'auth-footer.component.html',
    styleUrls: ['auth-footer.component.scss']
})
export class AuthFooterComponent {
    
    get settings(): Settings {
        return settings;
    }
}